<template>
  <div class="inspire-page">
    <section class="hero">
      <div class="hero-container flex flex-column">
        <div class="hero-text flex flex-column">
          <img src="../assets/inspire-logo1.png" alt="logo" class="brand-logo">
          <h4>INSPIRE LEADERSHIP SCHOOL</h4>
          <h2>
            Creating Leaders <br>
            Through Education
          </h2>
          <p>"Great leaders don't show you what to do, They show you how it's done"</p>
          <router-link
            class="btn flex"
            :to="{ name: 'Welcome' }"
          >
            Login <ArrowSmRightIcon class="align-icon" />
          </router-link>
        </div>
        <div class="hero-img flex">
          <img src="../assets/books.svg" alt="teacher">
          <p>“Today a reader, tomorrow a leader.”</p>
        </div>
      </div>
    </section>
    <section class="team flex">
      <div class="card card-container">
        <h3>School Director</h3>
        <img src="../assets/director.jpeg" alt="director">
        <h4>Ms. Nsama Chikonkolo</h4>
        <p>A passionate born leader, she holds a Bachelor's degree in  education  with a major in English and minor in History. Miss Chikonkolo is Currently  pursuing her Masters in Education management. She founded Inspire Leadership School with her partner in 2009. The leadership  aspect of the school is to educate the pupils who are referred as leaders into  creating whatever path they will choose in life with confidence  and know that they are the right people for the job assigned.</p>
      </div>
    </section>
    <section class="home-features-1 flex flex-column">
      <p class="vini">A leadership School for Children founded in 2009 and is working to ensure that all children achieve their maximum potential. The school believes in imparting leadership skills in children at a tender age thereby creating leaders through education. <br/>
      We have a Nursery section comprised of Baby Class, Middle Class and Reception.<br/>
      Lower primary from grade 1 to 4<br/>
      Upper primary from grade 5 to 7</p>
      <div class="karim">
          <div class="feature flex flex-column">
            <div class="feature-title">
              <h5>What We Offer</h5>
            </div>
            <p>Inspire Leadership School has facilities and an environment enabling children to explore and learn from. The school has qualified and caring staff and teachers who carry out training using verified syllabus programmes.<br/>
            The school also boasts of a well-organised computer lab where children are imparted with computer skills. Inspire Leadership School also provides wholesome meals for lunch for children.<br/>
            Amongst lessons offered, Inspire Leadership School offers French classes. For extracurricular activities, the school has sports and games every Wednesday and children have an opportunity to play at Olympic Youth Development Centre once every month.</p>
        </div>
        <div class="feature-img">
          <img src="../assets/crayons.jpg" alt="">
        </div>
      </div>
    </section>
    <section class="home-cards">
      <h4>Features</h4>
      <hr class="hr">
      <div class="home-cards-main">
        <div class="home-cards-cards">
          <div class="feature">
            <router-link
            :to="{ name: 'SchoolBus'}">
            <div class="feature-img">
              <img src="../assets/school-bus.svg" alt="school bus">
            </div>
            <div class="feature-title">
              <h5>School Buses</h5>
            </div>
            <div class="feature-detail">
              <p>Time buses with strictly adhered to and easily monitored routes covering most of Lusaka.</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Meals'}">
            <div class="feature-img undraw">
              <img src="../assets/breakfast.svg" alt="food">
            </div>
            <div class="feature-title">
              <h5>Meals</h5>
            </div>
            <div class="feature-detail">
              <p>Healthy and delicious meals prepared by the school.</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Clubs'}">
            <div class="feature-img">
              <img src="../assets/chess-board.svg" alt="chess">
            </div>
            <div class="feature-title">
              <h5>Extra curricular Activities</h5>
            </div>
            <div class="feature-detail">
              <p>Extra-curricular activities, Chess, Debate etc</p>
            </div>
            </router-link>
          </div>
          <div class="feature">
            <router-link
            :to="{ name: 'Events'}">
            <div class="feature-img undraw">
              <img src="../assets/goal.svg" alt="sport">
            </div>
            <div class="feature-title">
              <h5>Other features</h5>
            </div>
            <div class="feature-detail">
              <p>Sports, field trips, Computer lessons, Music and French classes</p>
            </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="home-demo-action">
      <div class="demo-content flex flex-column">
        <h2>Inspire Leadership School</h2>
        <p class="cloud">Creating Leaders Through Education</p>
        <p>“If your actions inspire others to dream more, learn more, do more and become more, you are a leader.”</p>
      </div>
      <div class="demo-image">
        <img src="../assets/Teacher.jpg" alt="">
      </div>
    </section>
    <section class="home-footer flex flex-column">
      <div class="footer-conmap">
        <div class="footer-content flex flex-column">
            <h2>Inspire Leadership School</h2>
            <h4>Creating Leaders Through Education</h4>
            <address>
              CONTACT US<br/>
              Call: 0978730723/0976130005 <br/>
              Email: inspireleadershipschool@gmail.com <br/>
              Visit: Plot no 31379 off Ring Road Chalala Lusaka, Zambia
            </address>
            <router-link
                class="btn"
                :to="{ name: 'Welcome' }"
            >
                Login
            </router-link>
            <div class="socials flex">
              <a href="mailto:inspireleadershipschool@gmail.com" class="icon" target="_blank">
                <img src="../assets/email.svg" alt="email">
              </a>
              <a href="https://facebook.com/inspireleadershipschool" class="icon" target="_blank">
                <img src="../assets/facebook.svg" alt="facebook">
              </a>
            </div>
        </div>
        <div class="footer-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3845.6953770168543!2d28.349443315017457!3d-15.446984118621321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19408c54ac0526bd%3A0xf7969458efffeb6d!2sInspire%20Leadership%20School!5e0!3m2!1sen!2szm!4v1651520823014!5m2!1sen!2szm" width="300" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <p class="copy">&copy; 2023 <br>
        Developed by <a href="https://schools.vitowe.com" class="vitowe" target="_blank">
        Vitowe</a>
      </p>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { ArrowSmRightIcon } from '@heroicons/vue/outline'

export default {
  name: 'Home',
  components: { ArrowSmRightIcon }
}
</script>

<style>
.inspire-page .hero {
  position: relative;
  min-height: 100vh;
}
.inspire-page .hero .brand-logo {
  margin-top: 3em;
  align-self: center;
  width: 150px;
}
.inspire-page .hero .hero-container {
  height: 100%;
  justify-content: center;
  align-content: center;
}
.inspire-page .hero .hero-container .hero-text {
  justify-content: center;
  align-content: center;
  color: var(--inspire-gold);
}
.inspire-page .hero h4 {
  text-transform: uppercase;
  font-size: 22px;
  padding-bottom: 4px;
  color: #fff;
}

.inspire-page .hero .hero-text p {
  color: var(--sidebar-item-active);
}
.inspire-page .hero h2 {
  font-size: 50px;
}
@media (min-width: 550px) {
  .inspire-page .hero h2 {
    font-size: 80px;
  }
}
.inspire-page .hero .btn {
  align-self: center;
  border-radius: 30px;
  align-content: center;
  justify-content: space-around;
  color: #fff;
}
.inspire-page .hero .hero-img {
  align-content: space-between;
  justify-content: space-between;
  color: #fff;
  font-size: 3em;
}
@media (max-width: 550px) {
  .inspire-page .hero .hero-img {
    font-size: 2em;
    flex-direction: column;
  }
  .inspire-page .team {
    flex-direction: column;
  }
}
.inspire-page .team {
  min-height: 30vh;
  justify-content: space-around;
}
.inspire-page .team .card {
  background-color: #fff;
  /* flex-basis: 50%; */
  font-size: 1.2em;
  color: var(--inspire-pewter);
}
.inspire-page .team .card h3 {
  font-weight: lighter;
  font-size: 0.9em;
  margin: 20px auto;
  text-transform: uppercase;
}
.inspire-page .team .card h4 {
  font-weight: lighter;
  color: var(--inspire-charcoal);
  font-size: 1.5em;
  margin: 20px auto;
}
.inspire-page .team .card p {
  margin-bottom: 20px;
  color: var(--inspire-gris);
}
.inspire-page .team .card img {
  width: 100px;
  height: 100px;
  border: 1px solid #ffdf00;
  border-radius: 50%;
}
.inspire-page .home-features-1 {
  color: #fff;
  min-height: 100vh;
}
.inspire-page .home-features-1 .vini {
  font-size: 1.5em;
}
.inspire-page .home-features-1 .karim {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 30px 5px;
}
.inspire-page .home-features-1 .feature-img {
  margin: 0 auto;
  padding: 1.5em;
}
.inspire-page .home-features-1 .feature {
  justify-content: center;
  align-content: center;
  text-align: left;
  font-size: 1.1em;
  padding: 1em;
}
.inspire-page .home-features-1 .feature .feature-title {
  text-align: center;
}
.inspire-page .home-features-1 .feature .feature-title h5 {
  margin-bottom: 1em;
  text-align: center;
  color: var(--inspire-shine);
  text-transform: uppercase;
}
.inspire-page .home-features-1 p {
  padding: 30px 5px;
}
.inspire-page .home-cards {
  background-color: var(--inspire-magnet);
  min-height: 50vh;
}
.inspire-page .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.inspire-page .home-cards a {
  text-decoration: none;
  color: inherit;
}
.inspire-page .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.inspire-page .home-cards .home-cards-main {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 1em;
}
.inspire-page .home-cards .home-cards-cards {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}
.inspire-page .home-cards-cards .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.inspire-page .home-cards-cards .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.inspire-page .home-cards-cards .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.inspire-page .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.inspire-page .feature .feature-img.undraw {
  width: 75px;
  margin: 5px auto;
}
.inspire-page .home-cards-cards .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
  background-color: var(--inspire-gold);
}
.home-demo-action {
  display: grid;
  grid-gap: 0.8rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 30px 5px;
  background-color: var(--inspire-gold);
  color: var(--inspire-charcoal);
  min-height: 70vh;
}
.inspire-page .home-demo-action .demo-content {
  flex-basis: 60%;
  justify-content: center;
  align-content: center;
  font-size: 1.5em;
}
.inspire-page .home-demo-action .demo-content .cloud{
  font-size: 1.5em;
  color: #fff;
  margin: 1em auto 1em 0;
}
.inspire-page .home-demo-action .btn {
  background: var(--inspire-gold);
  transition: color 300ms ease-in-out;
  padding: 0.3em 0.35em;
  font-size: 1.6em;
  color: var(--inspire-fossil);
  border: none;
  max-width: 250px;
  letter-spacing: 1px;
  align-self: center;
}
.inspire-page .home-demo-action .btn:hover,
.inspire-page .home-demo-action .btn:focus {
  color: #fff;
}
.inspire-page .home-demo-action .demo-image {
  min-width: 300px;
  max-width: 450px;
  margin: 0 auto;
  padding: 1.5em;
  background: var(--inspire-gold);
}
.inspire-page .home-demo-action .demo-image img{
  max-width: 300px;
}
</style>
